export enum TrialName {
  EQUINOX_GROUP_A = 'Equinox: Group A',
  EQUINOX_GROUP_B = 'Equinox: Group B',
}
